import { ChoiceChips as RootChoiceChips } from './ChoiceChips'
import { Item } from './Item'

export const ChoiceChips = Object.assign(RootChoiceChips, { Item })
